export default "__VITE_ASSET__BAQHAf77__"